import { render, staticRenderFns } from "./LocalList.vue?vue&type=template&id=0ad0136a&scoped=true&"
import script from "./LocalList.vue?vue&type=script&lang=js&"
export * from "./LocalList.vue?vue&type=script&lang=js&"
import style0 from "./LocalList.vue?vue&type=style&index=0&id=0ad0136a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad0136a",
  null
  
)

export default component.exports